import logo from './logo.svg';
import './App.css';
import { Link } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';

const App = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const playerRef = useRef(null);

  const toggleVideoPlayback = () => {
    setIsPlaying(!isPlaying);
  };

  const handleVideoClick = () => {
    toggleVideoPlayback();
  };

  useEffect(() => {
    const isFirstLoad = localStorage.getItem('firstLoad') === null;
    localStorage.setItem('firstLoad', 'false');

    if (isFirstLoad) {
      const timeoutId = setTimeout(() => {
        setIsPlaying(true);
      }, 1000); 
      return () => clearTimeout(timeoutId);
    } else {
      setIsPlaying(true);
    }
  }, []);

  return (
    <div className="app-container" data-aos="fade-down">
  <div data-aos="fade-right" data-aos-duration="1500">
    <img src={logo} alt="logo" className="img-log" />
  </div>
  <div className="title text-white" data-aos="fade-left" data-aos-duration="1500">
    LLAMADO A COMPARTIR
  </div>
  <ReactPlayer
        ref={playerRef}
        url={require('./galleta.mp4')}
        playing={isPlaying}
        controls={true}
        muted={true}
        onClick={handleVideoClick}
        className={`react-player-container ${isPlaying ? 'outline' : ''}`}
      />
      
      {/*<Link to="/login"> 
        <button type="button" className="button"> Calendario navideño </button>
  </Link>*/}
    </div>
  );
};

export default App;